// initial state
const state = {
  customFieldGroups: {},
};

const mutations = {
  setCustomFieldGroups(currentState, { groups }) {
    currentState.customFieldGroups = groups;
  },
};

export { mutations, state };
